export const adminPasswordConfig = password => ({ headers: { 'X-Admin-Password': password } });
export const adminPasswordErrorKey = error => ({
    ADMIN_PASSWORD_REQUIRED: 'adminConfirmation.required',
    ADMIN_PASSWORD_INVALID: 'adminConfirmation.invalid',
    ADMIN_PASSWORD_NOT_SET: 'adminConfirmation.notSet',
}[error?.response?.data?.code]);
